import api from './api';

const endpoint = '/api/v1/personal-shopper';

export default {

    async get() {
        return await api.get(endpoint);
    },

    async add(name, price, url, description) {
        return await api.post(endpoint, {
            name: name,
            price: price,
            url: url,
            description: description,
        });
    },

    async updateItem(itemId, price, quantity) {
        return await api.patch(`${endpoint}/${itemId}`, {
            price: price,
            quantity: quantity,
        });
    },

    async deleteItem(itemId) {
        return await api.delete(`${endpoint}/${itemId}`);
    }

}
